import React, { useState, useEffect } from "react";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
//import ReportFormat from "./ReportFormat";
import CommonFormatComponent from "./CommonFormatComponent";
import ReportStatus from "./ReportStatus";
import SampleStatus from "./SampleStatus"
import { BreadcrumbPage } from "../../shared";
import { SampleStatusData, ReportStatusData, TotalSampleStatusData, TotalReportStatusData, SampleStatusColor, ReportStatusColor } from "./SampleStatusInstantiation";
import { getCookie } from "../../services/Cookies";
import { getRequest, postRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from '../../action';
import { useDispatch } from 'react-redux';
import { getCurrentDate, getCurrentDateOfBelow } from "../../services/DateServices";
const reportDataJson = require("../../../data/reportData.json");

export default function DashboardLayout(props) {
  const dispatch = useDispatch();
  const [reportData, setReportData] = useState([]);
  const [sampleStatusDetails, setSampleStatusDetails] = useState([SampleStatusData]);
  const BreadcrumbList = [{ name: "Dashboard", url: "" }];
  const [open, setOpen] = React.useState(process.env.REACT_APP_UNDERMAINTANCEMESSAGE != "" ? true : false);
  const [subValue, setsubValue] = React.useState("")

  const [reportDetailsList, setReportDetailsList]
    = useState({
      fuelAnalysisSampleStatus: [], lubeAnalysisSampleStatus: [], totAnalysisSampleStatus: [],
      fuelAnalysisReportStatus: [], lubeAnalysisReportStatus: [], totAnalysisReportStatus: []
    });
  const [reportDetailsListTotal, setReportDetailsListTotal]
    = useState({
      fuelAnalysisSampleStatus: [], lubeAnalysisSampleStatus: [], totAnalysisSampleStatus: [],
      fuelAnalysisReportStatus: [], lubeAnalysisReportStatus: [], totAnalysisReportStatus: []
    });



  useEffect(() => {
    setReportData(reportDataJson);
    getReports(getCookie("clientId"));
    // pipeChartFormat();
  }, []);

  const getReports = (customerKeys) => {
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Report/Dashboard`;
    const data = {
      "CustomerKeys": customerKeys,
      // "StartDate": "2020-12-01",
      // "EndDate": "2022-01-01"

      "StartDate": getCurrentDateOfBelow(30),
      "EndDate": getCurrentDate()
    }
    postRequest(url, data)
      .then((res) => {
        ////console.log(res);
        const result = res.data;
        const objData = {
          fuelAnalysisReportStatus: getReportData(res.data.fuelAnalysisReportStatus),
          lubeAnalysisReportStatus: getReportData(res.data.lubeAnalysisReportStatus),
          totAnalysisReportStatus: getReportData(res.data.totAnalysisReportStatus),
          fuelAnalysisSampleStatus: getSampleData(res.data.fuelAnalysisSampleStatus),
          lubeAnalysisSampleStatus: getSampleData(res.data.lubeAnalysisSampleStatus),
          totAnalysisSampleStatus: getSampleData(res.data.totAnalysisSampleStatus)
        }
        const objTotalData = {
          totalReportStatus: getReportTotalData(res.data),
          totalSampleStatus: getSampleTotalData(res.data)
        }
        ////console.log(objTotalData);
        setReportDetailsList(objData);
        setReportDetailsListTotal(objTotalData);
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });

        ////console.log(error);
      });
  }
  const getSampleData = (data) => {
    let analysList = [];
    let analysServiceList = [];
    let analysStatusList = [];
    let max = 0;
    data.map((row, index) => {
      if (row.samplesCount > max)
        max = row.samplesCount;
    });
    data.map((row, index) => {
    
      const reportIndex = analysServiceList.indexOf(row.serviceType.trim());

      if (reportIndex > -1) {
        const IndexForStatus = analysStatusList[reportIndex].indexOf(row.status);
        if (IndexForStatus > -1) {
          const samplePipeData = {
            "title": row.status,
            "color": SampleStatusColor[IndexForStatus],
            "value": row.samplesCount,
            "max": max,
            "min": 0
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        } else {
          analysStatusList[reportIndex].push(row.status);
          const analysStatusListIndex = analysStatusList[reportIndex].indexOf(row.status);
          const samplePipeData = {
            "title": row.status,
            "color": SampleStatusColor[analysStatusListIndex],
            "value": row.samplesCount,
            "max": max,
            "min": 0
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        }
      } else {
        analysServiceList.push(row.serviceType.trim());
        const IndexForStatus = analysServiceList.indexOf(row.serviceType.trim());
        const arrStatus = [];
        arrStatus.push(row.status)
        analysStatusList[IndexForStatus] = arrStatus;
        const analysStatusListIndex = analysStatusList[IndexForStatus].indexOf(row.status);
        const samplePipeData = {
          "title": row.status,
          "color": SampleStatusColor[analysStatusListIndex],
          "value": row.samplesCount,
          "max": max,
          "min": 0
        }
        let SampleStatusFormatData = [];
        SampleStatusFormatData.push(samplePipeData);
        const SampleStatusDataEdit = { ...SampleStatusData, caseCount: row.samplesCount, title: row.serviceType, typeOfCase: SampleStatusFormatData }
        analysList.push(SampleStatusDataEdit);
      }
    })
    return analysList;
  }
  const getReportData = (data) => {
    let analysList = [];
    let analysServiceList = [];
    let analysStatusList = [];
    let max = 0;
    data.map((row, index) => {
      if (row.samplesCount > max)
        max = row.samplesCount;
    });
    data.map((row, index) => {
      ////console.log(index, row);
      const reportIndex = analysServiceList.indexOf(row.serviceType.trim());
      if (reportIndex > -1) {
        const IndexForStatus = analysStatusList[reportIndex].indexOf(row.status);
        if (IndexForStatus > -1) {
          const samplePipeData = {
            "title": row.status,
            "color": ReportStatusColor[IndexForStatus],
            "value": row.samplesCount,
            "max": max,
            "min": 0
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        } else {
          analysStatusList[reportIndex].push(row.status);
          const analysStatusListIndex = analysStatusList[reportIndex].indexOf(row.status);
          const samplePipeData = {
            "title": row.status,
            "color": ReportStatusColor[analysStatusListIndex],
            "value": row.samplesCount,
            "max": max,
            "min": 0
          }
          analysList[reportIndex].caseCount = analysList[reportIndex].caseCount + row.samplesCount;
          analysList[reportIndex].typeOfCase.push(samplePipeData);
        }
      } else {
        analysServiceList.push(row.serviceType.trim());
        const IndexForStatus = analysServiceList.indexOf(row.serviceType.trim());
        const arrStatus = [];
        arrStatus.push(row.status)
        analysStatusList[IndexForStatus] = arrStatus;
        const analysStatusListIndex = analysStatusList[IndexForStatus].indexOf(row.status);
        const samplePipeData = {
          "title": row.status,
          "color": ReportStatusColor[analysStatusListIndex],
          "value": row.samplesCount,
          "max": max,
          "min": 0
        }
        let SampleStatusFormatData = [];
        SampleStatusFormatData.push(samplePipeData);
        const SampleStatusDataEdit = { ...ReportStatusData, caseCount: row.samplesCount, title: row.serviceType, typeOfCase: SampleStatusFormatData }
        analysList.push(SampleStatusDataEdit);
      }
    })
    return analysList;
  }
  const getDefaultTab = () => {
    //
    const serviceTypes = getCookie("serviceTypes").split(',');
    let tabIndex = [];
    serviceTypes.forEach((serviceType) => {
      if (serviceType == "TOT") {
        tabIndex.push(2);
        //setsubValue("Tot")
      }
      if ((serviceType == "Lube Analysis" || serviceType == "OCM" || serviceType == "SDA" || serviceType == "Grease" || serviceType == "Compatibility" || serviceType == "Ferrography")) {
        tabIndex.push(1);
        //setsubValue("Lube")
      }
      if ((serviceType == "FQT" || serviceType == "FSC" || serviceType == "FCA" || serviceType == "GCMS" || serviceType == "BQS")) {
        tabIndex.push(0);
        // setsubValue("Fuel")
      }

    });
    return tabIndex.length > 0 ? tabIndex : [0];
  }
  const getReportTotalData = (data) => {
    let analysList = [];
    let analysStatusList = [];
    let countCase = 0;
    let defTab = getDefaultTab();

    if (defTab.indexOf(0) > -1) {
      let max = 0;

      data.fuelAnalysisReportStatus.map((row, index) => {
        if (max < row.samplesCount)
          max = row.samplesCount;
      });
      max = max + 30;
      data.fuelAnalysisReportStatus.map((row, index) => {
        ////console.log(row);
        let analysIndex = analysStatusList.indexOf(row.status);
        if (analysIndex > -1) {
          countCase = countCase + row.samplesCount;
          analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
        } else {
          analysStatusList.push(row.status);
          let rIndex = analysStatusList.indexOf(row.status);
          countCase = countCase + row.samplesCount;
          analysList.push({
            "title": row.status,
            "color": ReportStatusColor[rIndex],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          })
        }
      });
    }
    if (defTab.indexOf(1) > -1) {
      let max = 0;
      data.lubeAnalysisReportStatus.map((row, index) => {
        if (max < row.samplesCount)
          max = row.samplesCount;
      });
      max = max + 30;
      data.lubeAnalysisReportStatus.map((row, index) => {
        ////console.log(row);
        let analysIndex = analysStatusList.indexOf(row.status);
        if (analysIndex > -1) {
          countCase = countCase + row.samplesCount;
          analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
        } else {
          analysStatusList.push(row.status);
          let rIndex = analysStatusList.indexOf(row.status);
          countCase = countCase + row.samplesCount;
          analysList.push({
            "title": row.status,
            "color": ReportStatusColor[rIndex],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          })
        }
      });
    }
    if (defTab.indexOf(2) > -1) {
      let max = 0;
      data.totAnalysisReportStatus.map((row, index) => {
        if (max < row.samplesCount)
          max = row.samplesCount;
      });
      max = max + 30;
      data.totAnalysisReportStatus.map((row, index) => {
        ////console.log(row);
        let analysIndex = analysStatusList.indexOf(row.status);
        if (analysIndex > -1) {
          countCase = countCase + row.samplesCount;
          analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
        } else {
          countCase = countCase + row.samplesCount;
          analysStatusList.push(row.status);
          let rIndex = analysStatusList.indexOf(row.status);
          analysList.push({
            "title": row.status,
            "color": ReportStatusColor[rIndex],
            "value": row.samplesCount,
            "min": 0,
            "max": max
          })
        }
      });
    }
    return { ...TotalReportStatusData, caseCount: countCase, typeOfCase: analysList };
  }
  const getSampleTotalData = (data) => {
    let analysList = [];
    let analysStatusList = [];
    let countCase = 0;
    let max = 0;
    data.fuelAnalysisSampleStatus.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });
    max = max + 30;
    data.fuelAnalysisSampleStatus.map((row, index) => {
      ////console.log(row);
      let analysIndex = analysStatusList.indexOf(row.status);
      if (analysIndex > -1) {
        countCase = countCase + row.samplesCount;
        analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
      } else {
        countCase = countCase + row.samplesCount;
        analysStatusList.push(row.status);
        let rIndex = analysStatusList.indexOf(row.status);
        analysList.push({
          "title": row.status,
          "color": SampleStatusColor[rIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        })
      }
    })
    max = 0;
    data.lubeAnalysisSampleStatus.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });
    max = max + 30;
    data.lubeAnalysisSampleStatus.map((row, index) => {
      ////console.log(row);
      let analysIndex = analysStatusList.indexOf(row.status);
      if (analysIndex > -1) {
        countCase = countCase + row.samplesCount;
        analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
      } else {
        countCase = countCase + row.samplesCount;
        analysStatusList.push(row.status);
        let rIndex = analysStatusList.indexOf(row.status);
        analysList.push({
          "title": row.status,
          "color": SampleStatusColor[rIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        })
      }
    })
    max = 0;
    data.totAnalysisSampleStatus.map((row, index) => {
      if (max < row.samplesCount)
        max = row.samplesCount;
    });
    max = max + 30;
    data.totAnalysisSampleStatus.map((row, index) => {
      ////console.log(row);
      let analysIndex = analysStatusList.indexOf(row.status);
      if (analysIndex > -1) {
        countCase = countCase + row.samplesCount;
        analysList[analysIndex].value = analysList[analysIndex].value + row.samplesCount
      } else {
        countCase = countCase + row.samplesCount;
        analysStatusList.push(row.status);
        let rIndex = analysStatusList.indexOf(row.status);
        analysList.push({
          "title": row.status,
          "color": SampleStatusColor[rIndex],
          "value": row.samplesCount,
          "min": 0,
          "max": max
        })
      }
    })
    return { ...TotalSampleStatusData, caseCount: countCase, typeOfCase: analysList };
  }
  
  const handleClose1 = () => {
    setOpen(false);
  };
const getSubTypeValue = (data) => {
    setsubValue(data)
  }
  const [subData, setsubData] = React.useState("")
  const getSubdata = (data) => {
    //
    setsubData(data)
  }
  return (
    <div>
      <Box component="main" px={3} display="flex">
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Box display="dlock">
              <BreadcrumbPage rows={BreadcrumbList} />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box component="main" p={3} pb={2} display="flex">
        <Grid container>
          <Grid item xs={12} sm={12} md={4}>
            <Box
              component="div"
              display="block"
              style={{ marginTop: 2, cursor: "pointer" }}
              pr={1}
            >
              {" "}
              {reportData.length ? (
                <CommonFormatComponent
                  type="SampleStatus"
                  key="SampleFormatPart"
                  sampleStatusDetails={reportDetailsList}
                  row={reportDetailsListTotal.totalSampleStatus || {}}
                  subValue={subValue}

                />
              ) : (
                ""
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={8} className="dashboard-right">
            <Box component="div" display="block" pl={1}>
              <SampleStatus
                reportObj={reportDetailsList} sampleStatusDetails={reportDetailsList} subValue={subValue}
                subType={getSubTypeValue}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box component="main" p={3} pt={1} display="flex">
        <Grid container>
          <Grid item xs={12} sm={12} md={4}>
            <Box
              component="div"
              display="block"
              style={{ marginTop: 2, cursor: "pointer" }}
              pr={1}
            >
              {" "}
              {reportData.length ? (
                <CommonFormatComponent
                  type="ReportStatus"
                  key="ReportFormatPart"
                  sampleStatusDetails={reportDetailsList}
                  row={reportDetailsListTotal.totalReportStatus || {}}
                  subData={subData}
                />
              ) : (
                ""
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={8} className="dashboard-right">
            <Box component="div" display="block" pl={1}>
              <ReportStatus key="ReportDataPart"
                reportObj={reportDetailsList}
                reportStatusDetails={reportDetailsList}
                subType={getSubdata}
                subData={subData} />
            </Box>
          </Grid>
        </Grid>
</Box>
      <Box component="main" p={0} pt={0}  >
        <Grid item xs={12} sm={12} md={12} className="dashboard-right">
          <Box component="p" mt={0} pl={4} className="redcopy" style={{ fontSize: "1.4rem" }}>Use of this system is monitored for security and administration purposes and accessing this system constitutes consent to such monitoring.
            {/*and {getCookie("clientName")}.*/}</Box>
          <Box component="p" mt={0} pl={4} className="redcopy" style={{ fontSize: "1.8rem" }}>Unauthorised access of this system or unauthorised use of the information on this system by authorised users or others is prohibited and may be subject to criminal and civil penalties under applicable laws.
            {/*and {getCookie("clientName")}.*/}</Box>
        </Grid>
      </Box>
    </div>
  );
}
